/* eslint-disable */
export default {
    cp_profile_details_saved: "Your data has been saved",
    cp_profile_details_not_saved: "Your changes have not yet been saved",
    cp_profile_logout: "Log out",
    cp_profile_general_error: "An error occurred while processing your request. Please try again.",
    cp_profile_save: "Save",
    cp_profile_first_name: "First name",
    cp_profile_infix: "Infix",
    cp_profile_last_name: "Last name",
    cp_profile_gender: "Gender",
    cp_profile_male: "Male",
    cp_profile_female: "Female",
    cp_profile_other: "Other",
    cp_profile_settings_email_on_report_permissions: "Receive notification when participant changes permission for sharing the report",
    cp_profile_unspecified: "Je préfère ne pas dire ça",
    cp_profile_language_preference_success: "Préférence linguistique enregistrée avec succès",
    cp_profile_language_preference_failed: "Impossible d'enregistrer la préférence linguistique"
};
